var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',{class:{ inAdmin:!_vm.isClientFacing, archerHeader:true },attrs:{"height":"auto"}},[_c('layout-header')],1),_c('el-main',[_c('router-view')],1),_c('layout-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }